import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { DeNghiMuaHang, DeNghiMuaHangCT, HHModel, DM_DuyetChiTietMH } from '../de-nghi-mua-hang-model/de-nghi-mua-hang.model';
const API_ROOT_URL = environment.ApiRoot + '/muahang';

@Injectable()
export class DeNghiMuaHangService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DeNghiMuaHang_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	getDeNghiMuaHangDetail(itemId): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DeNghiMuaHang_Get_Detail?Id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}

	getSoPhieuTiepTheo(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+'/DeNghiMuaHang_Get_NextSP', { headers: httpHeaders });
	}

	addDeNghiMuaHang(item: DeNghiMuaHang): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHang>(API_ROOT_URL+'/DeNghiMuaHang_Insert', item, { headers: httpHeaders });
	}

	updateDeNghiMuaHangWithDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHang>(API_ROOT_URL+'/DeNghiMuaHang_Update_With_Detail', item, { headers: httpHeaders });
	}

	updateStateNH(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHang>(API_ROOT_URL+'/DeNghiMuaHang_Update_StateNH', item, { headers: httpHeaders });
	}

	deleteDeNghiMuaHang(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DeNghiMuaHang_Delete?Id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}

	cancelDeNghiMuaHang(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DeNghiMuaHang_Cancel?Id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}

	xacNhanDeNghiMuaHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHang>(API_ROOT_URL+'/DeNghiMuaHang_XacNhanMuaHang', item, { headers: httpHeaders });
	}

	GuiDuyetGiaDeNghiMuaHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHang>(API_ROOT_URL+'/DeNghiMuaHang_GuiDuyetGia', item, { headers: httpHeaders });
	}

	DuyetDeNghiMuaHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiMuaHang>(API_ROOT_URL+'/DeNghiMuaHang_DuyetMuaHang', item, { headers: httpHeaders });
	}

	downloadTemplate(itemId: any): string {
		return API_ROOT_URL + `/DeNghiMuaHang_DownFileDK?idCtdn=${itemId}`;
	}

	addHH(item: HHModel): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/HH_Insert', item, { headers: httpHeaders });
	}

	listHangHoa() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/Hang_Hoa_List' ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	listListNCC() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_NCC_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}
	listNV() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_NhanVien_List' ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	listPB() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_PhongBan_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}
	listState() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/dungchung' + `/TrangThaiPhieu_List?category=PDNMH` ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	listQLGMNCC(listIDHH: number[]) : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/dungchung' + '/QLGM_NCC_List' ;
		return this.http.post<any>(url , listIDHH, { headers: httpHeaders });
	}

	luuKetQuaDuyet(item: DM_DuyetChiTietMH): Observable<any> {
		const url = API_ROOT_URL + '/LuuKetQuaDuyet';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, item, { headers: httpHeaders });
	}
}
